import React from "react";
import classes from "./Navigation.module.css";
import { NavLink } from "react-router-dom";
import {
  HomeIcon,
  BellIcon,
  CalendarIcon,
  ClockIcon,
  PinIcon,
  CarIcon,
  PeopleIcon,
  StarIcon,
  ListIcon,
  ShareIcon,
} from "./icons";

const links = [
  { to: "/", label: "Startseite", Icon: HomeIcon },
  { to: "/aktuell", label: "Aktuell", Icon: BellIcon },
  { to: "/termine", label: "Termine / Anlässe", Icon: CalendarIcon },
  { to: "/rueckblick", label: "Rückblick / Galerie", Icon: ClockIcon },
  { to: "/anschlagbrett", label: "Anschlagbrett", Icon: PinIcon },
  { to: "/stammtisch", label: "Stammtische", Icon: CarIcon },
  { to: "/vorstand", label: "Vorstand", Icon: PeopleIcon },
  { to: "/mitglied-werden", label: "Mitglied werden", Icon: StarIcon },
  { to: "/kontakt", label: "Kontakt", Icon: ListIcon },
  { to: "/links", label: "Links", Icon: ShareIcon },
];

const Navigation = (props) => {
  const cls = [classes.Navigation];
  if (props.open) cls.push(classes.Open);

  return (
    <section className={cls.join(" ")}>
      <div style={{ paddingBottom: "100px" }}>
        {links.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            onClick={props.closeNav}
            className={({ isActive }) =>
              classes.NavLink + (isActive ? " " + classes.Active : "")
            }
            to={to}
            end={to === "/"}
          >
            <Icon />
            <p>{label}</p>
          </NavLink>
        ))}
      </div>
    </section>
  );
};

export default Navigation;
